var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (3),
      expression: "3"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          Наша компания успешно работает на российском IT-рынке с 2009 года.\n          Уже 12 лет под брендом ЭБК мы производим качественные онлайн-сервисы\n          в секторах b2b и b2c, основанные на кредитной информации и смежных\n          данных (ЦККИ, БКИ, ФНС, межбанковский обмен информацией).\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "title"
    }
  }, [_vm._v("Контакты:")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v("\n          620014, г. Екатеринбург, ул. Сакко и Ванцетти, 64, 4 этаж, офис 404\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v(" тел. +7 (495) 374-87-74 ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', [_vm._v(" e-mail: support@exbico.ru ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.left",
      modifiers: {
        "left": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" Связаться с поддержкой ")])], 1)])]), _vm._v(" "), _c('v-modal', {
    attrs: {
      "active": _vm.isShowModal
    },
    on: {
      "close": function($event) {
        _vm.isShowModal = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-text', {
    attrs: {
      "type": "headline"
    }
  }, [_vm._v("Обращение в поддержку")]), _vm._v(" "), _c('v-icon-button', {
    staticStyle: {
      "margin-left": "249px"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" close ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('textarea', {
    staticStyle: {
      "width": "574px",
      "height": "316px",
      "outline": "none",
      "resize": "none",
      "border": "1px solid rgb(214,214,214)",
      "border-radius": "2px",
      "padding": "5px"
    },
    attrs: {
      "label": "message",
      "placeholder": "Оставьте ваше сообщение..."
    },
    on: {
      "input": function($event) {
        _vm.updateMessage($event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": _vm.requestSupport
    }
  }, [_vm._v(" Оставить заявку ")])], 1)])]), _vm._v(" "), _c('v-modal', {
    attrs: {
      "active": _vm.isShowConfirm
    },
    on: {
      "close": function($event) {
        _vm.isShowConfirm = false
      }
    }
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [_c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v(" Спасибо ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }],
    attrs: {
      "type": "title"
    }
  }, [_vm._v("\n          Ваша заявка принята\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (1),
      expression: "1",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('v-text', {
    directives: [{
      name: "margin",
      rawName: "v-margin.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_vm._v("\n          Мы свяжемся с вами в ближайшее время.\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }, {
      name: "margin",
      rawName: "v-margin.top",
      value: (1),
      expression: "1",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-button', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" Закрыть ")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e8d558","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/contacts/Contacts.vue
// module id = 1020
// module chunks = 0